import { ApiEndpointClient } from './resource-client';
export class TaskTemplatesClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, 'order-api/v1');
        this.http = http;
    }
    getTaskTemplates = async (options) => this.get('/task-templates/', { response: 'content-type-or-empty', ...options });
    patchTaskTemplate = async ({ taskTemplateId, operations }, options) => {
        await this.patch(`/task-templates/${taskTemplateId}`, { ...options, json: operations, response: 'raw' });
    };
    createTaskTemplate = async ({ taskTemplate }, options) => this.post('/task-templates/', { response: 'content-type-or-empty', ...options, json: taskTemplate });
    deleteTaskTemplate = async ({ taskTemplateId }, options) => {
        return this.delete(`/task-templates/${taskTemplateId}`, { ...options, response: 'content-type-or-empty' });
    };
    getTaskPreviews = async ({ templateIds, orderId }, options) => this.get(`/task-templates/task-previews?order_uuid=${orderId}&template_uuids=${templateIds.join(',')}`, {
        response: 'content-type-or-empty',
        ...options,
    });
    createMultipleTasks = async ({ tasks }, options) => this.post('/tasks/', { response: 'content-type-or-empty', ...options, json: tasks });
}
